<template>
  <div>
    <h4 class="vue-title">
      <strong>{{$t("MANAGER")}}</strong>
    </h4>

    <div class="float-right add-text-size" >
      {{$t("ADD")}}
      <a href="#">
        <em class="fas fa-plus-circle icon-size"></em>
      </a>
    </div>

    <v-client-table :data="this.tableData" :columns="this.columns" :options="this.options">
      <span slot="アクション" slot-scope="{ row }">
        <button v-on:click="edit(row.id)" class="btn btn-info btn-sm">
          <em class="fa fa-edit"></em>Edit
        </button>
        &nbsp;
        <button v-on:click="delet(row.id)" class="btn btn-danger btn-sm">
          <em class="fa fa-trash"></em>Delete
        </button>
      </span>
    </v-client-table>
    <b-modal id="modal-1" title="Delete Confimation" hide-footer>
      <p class="my-4">「クリニック」提携先マスターを削除しますがよろしいですか？</p>
      <b-button class="mt-3" variant="danger" block @click="$bvModal.hide('modal-1')">Delete</b-button>
      <b-button class="mt-3" block @click="$bvModal.hide('modal-1')">Close</b-button>
    </b-modal>
  </div>
</template>

<script>

export default {
  name: "partnerList",
  data() {
    return {
      pageLmit: 5,
      header: ["StoreManagement"],
      columns: [
        "ID",
        "氏名",
        "EMAIL",
        "携帯",
        "権限",
        "ステータス",
        "アクション"
      ],
      tableData: [
        {
          ID: 123,
          氏名: "石田一郎",
          EMAIL: "taro@xxx.xom",
          携帯: "0312345678",
          権限: "管理者",
          ステータス: "有効"
        },
        {
          ID: 124,
          氏名: "石田一郎",
          EMAIL: "taro@xxx.xom",
          携帯: "0312345678",
          権限: "管理者",
          ステータス: "有効"
        },
        {
          ID: 125,
          氏名: "石田一郎",
          EMAIL: "taro@xxx.xom",
          携帯: "0312345678",
          権限: "管理者",
          ステータス: "有効"
        },
        {
          ID: 126,
          氏名: "石田一郎",
          EMAIL: "taro@xxx.xom",
          携帯: "0312345678",
          権限: "管理者",
          ステータス: "有効"
        },
        {
          ID: 127,
          氏名: "石田一郎",
          EMAIL: "taro@xxx.xom",
          携帯: "0312345678",
          権限: "管理者",
          ステータス: "有効"
        }
      ],
      options: {
        // see the options API
        html: true,
        perPageValues: [],
        perPage: 5,
        headings: "Partner",
        sortable: ["id", "提携先カテゴリー名", "ステータス"],
        resizableColumns: true,
        filterable: false,
        texts: {
          filter: "",
          filterPlaceholder: ""
        }
      },
      columnsChild: ["id", "提携先カテゴリー名", "ステータス", "アクション"],
      tableChildData: [
        {
          id: 543,
          提携先カテゴリー名: "クリニック",
          ステータス: "アクティブ",
          html: true
        },
        { id: 542, 提携先カテゴリー名: "歯科", ステータス: "アクティブ" }
      ],
      optionsChild: {
        // see the options API
        html: true,
        perPageValues: [],
        perPage: 5,
        headings: "Partner",
        sortable: ["id", "提携先カテゴリー名", "ステータス"],
        resizableColumns: true,
        filterable: false,
        texts: {
          filter: "",
          filterPlaceholder: ""
        }
      }
    };
  },
  components: {  },
  methods: {
    delet(id) {
      this.$bvModal.show("modal-1");
    },
    edit(id) {
      this.$router.push("/createPartner");
    }
  }
};
</script>
<style>
.add-text-size{
font-size: 17px;
}
.icon-size{
  padding:3px;
}
</style>